export const MAX_DISCOUNT = 50

export const defaultItemInput = { quantity: 1, discount: 0 }

export const formatCurrency = (value) =>
  Number(value).toLocaleString('en-US', { style: 'currency', currency: 'USD' })

export const clampQuantity = (value, maxQty = Infinity) =>
  Math.max(1, Math.min(maxQty, Math.trunc(Number(value) || 1)))

export const clampDiscount = (value) =>
  Math.max(0, Math.min(MAX_DISCOUNT, Number(value) || 0))

export const buildCartItem = (unit, input = defaultItemInput) => {
  const quantity = clampQuantity(input.quantity, unit.qty)
  const itemdiscount = clampDiscount(input.discount)
  const discprice = Number((unit.price * (1 - itemdiscount / 100)).toFixed(2))
  const lineSubtotal = Number((discprice * quantity).toFixed(2))
  const lineDiscount = Number((unit.price * quantity - lineSubtotal).toFixed(2))

  return {
    id: unit._id,
    upc: unit.upc,
    cid: unit.cid,
    item: unit.item,
    manufacturer: unit.manufacturer,
    subname: unit.subname,
    price: Number(unit.price),
    allqty: unit.qty,
    quantity,
    itemdiscount,
    discprice,
    lineSubtotal,
    lineDiscount
  }
}

export const computeTotals = (cartItems, shipping, taxrate) => {
  const subtotal = cartItems.reduce((sum, item) => sum + item.lineSubtotal, 0)
  const discount = cartItems.reduce((sum, item) => sum + item.lineDiscount, 0)
  const taxes = ((subtotal + shipping) * taxrate) / 100
  const total = (subtotal + shipping) * (1 + taxrate / 100)

  return { subtotal, discount, shipping, taxes, total }
}

// Shape expected by the receipt renderer: [totals, ...lines]
export const buildReceiptPayload = (sale) => [
  {
    total: sale.total.toFixed(2),
    subtotal: sale.subtotal.toFixed(2),
    discount: sale.discount.toFixed(2),
    shipping: sale.shipping.toFixed(2),
    taxes: sale.taxes.toFixed(2)
  },
  ...sale.items.map((line) => ({
    _id: line.inventory,
    upc: line.upc,
    saleqty: line.quantity,
    item: line.item,
    manufacturer: line.manufacturer,
    subname: line.subname,
    price: Number(line.price).toFixed(2),
    itemdiscount: line.itemdiscount
  }))
]

export const buildReceiptFilename = (barcode, name, now = new Date()) => {
  const pad = (n) => `0${n}`.slice(-2)
  const stamp = `${pad(now.getDate())}${pad(now.getMonth() + 1)}${now.getFullYear()}${pad(now.getHours())}${pad(now.getMinutes())}`
  return `${stamp}-${barcode}-${name || 'receipt'}.png`
}
